import React from "react";
import "../pages/Proyect.css";
import rick from "../Assets/rick-desk.png";
import BackButton from "../componets/BackButton";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import reactt from "../Assets/react_p.png";
import firee from "../Assets/firebase_p.png";

export const RickAndMorty = () => {
  const handleWebButtonClick = () => {
    window.location.href = "https://655cf394cceec205aeca6424--rick-and-morty-sgr.netlify.app/";
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/Rick-And-Morty";
  };

  return (
    <div className="proyect-container">
      <BackButton />
      <div className="proyect-header">
        <h1>Rick And Morty</h1>
    
      <div className="proyect-description">
        <p id="paragraph">
        This React application provides an interactive experience where users can explore and discover detailed information about the characters from the popular series "Rick and Morty." The interface features informative cards displaying relevant data for each character. Additionally, users can search for characters and add them to favorites.
        </p>
      </div>
      <div className="proyect-buttons">
        <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
        <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
  
        <img src={cssp} alt="CSS" className="computer" />
        <img src={reactt} alt="React" className="computer" />

      </div>  </div>
      <img
        id="new"
        src={rick}
        alt="Learning List"
        className="learning-image"
      />
    </div>
  );
};
